





















import {Component, Vue} from 'vue-property-decorator'
import {Action, Mutation} from 'vuex-class'
import AppHeader from '@/components/common/AppHeader.vue'
import SurveyListItem from './SurveyListItem.vue'
import SurveyModel from '@/classes/SurveyModel'
import {Task} from '@/store/types'

@Component({
  components: {
    AppHeader,
    SurveyListItem,
  },
})
export default class SurveyAttentionList extends Vue {

  @Mutation('setLoader') public setLoader!: any
  @Action('getTaskList') public getTaskList: any

  public pendingSurveys: Task[] = []

  public created() {
    this.setLoader(true)
    this.getTaskList([`status=${SurveyModel.STATUS.PENDING}`])
      .then((response: Task[]) => {
        this.pendingSurveys = response
        this.setLoader(false)
      })
  }
  public back() {
    this.$router.back()
  }
}
